export const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    cursor: 'pointer',
    position: 'relative',
  },
  text: {
    fontSize: '14px',
    fontWeight: 500,
    color: (theme) => `${theme.palette.blues.blue600}!important`,
  },
  button: { display: 'flex', alignItems: 'center', gap: '8px' },
  menu: {
    padding: 0,
    '& .MuiPaper-root': {
      borderRadius: '12px',
    },
  },
  paper: {
    maxWidth: '200px',
    padding: 0,
    width: '100%',
  },
  menuList: {
    padding: 0,
    width: '100%',
    minWidth: '100px',
  },
  menuItem: {
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    width: '100%',
    backgroundColor: (theme) => theme.palette.white.paper,

    svg: {
      display: 'flex',
      alignItems: 'center',
    },
  },
};
